import { Spinner } from '@klaro7/ui';

import { useResendCredentials } from '../hooks/useAdminProfessionals';

/**
 * Icon button (admin) to re-send the access-credentials email to an already-approved
 * professional. Shown next to the verification actions. Confirms first, since it
 * resets the consultant's provisional password.
 */
export function ResendCredentialsButton({
  id,
  size = 'sm',
}: {
  id: string;
  size?: 'sm' | 'md';
}) {
  const resend = useResendCredentials();

  const box = size === 'md' ? 'h-9 w-9' : 'h-8 w-8';
  const icon = size === 'md' ? 'h-5 w-5' : 'h-4 w-4';

  const handleClick = () => {
    if (resend.isPending) return;
    const ok = window.confirm(
      'Re-inviare la mail con le credenziali di accesso?\n\nLa password provvisoria verrà reimpostata e il professionista dovrà cambiarla al primo accesso.'
    );
    if (ok) resend.mutate(id);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={resend.isPending}
      title="Re-invia mail credenziali di accesso"
      aria-label="Re-invia mail credenziali di accesso"
      className={`inline-flex ${box} items-center justify-center rounded-lg border border-brand-teal/30 text-brand-teal transition-colors hover:bg-brand-teal/10 disabled:opacity-50`}
    >
      {resend.isPending ? (
        <Spinner size="sm" />
      ) : (
        <svg className={icon} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 12 3.269 3.125A59.769 59.769 0 0121.485 12 59.768 59.768 0 013.27 20.875L5.999 12zm0 0h7.5"
          />
        </svg>
      )}
    </button>
  );
}
